import { nextTick, Ref, ref } from "vue";
import DSButton from "@/src/design_system/button_and_controls/button/components/DSButton.vue";

export const useScrollToSelectedPeriodOption = ({
  selectedValue,
  periodSelectorRef,
}: {
  selectedValue: number | undefined;
  periodSelectorRef: Ref<HTMLDivElement | null>;
}) => {
  const buttonRefs = ref<Map<number, InstanceType<typeof DSButton>>>(new Map());

  const setButtonRef = (el: InstanceType<typeof DSButton> | undefined, value: number) => {
    if (el) {
      buttonRefs.value.set(value, el);
    }
  };

  const scrollToSelected = async () => {
    await nextTick();
    if (!shouldScrollToSelected()) return;

    const selectedButtonElement = getSelectedButtonElement();
    const periodSelectorElement = getPeriodSelectorElement();

    if (!selectedButtonElement || !periodSelectorElement) return;

    const scrollTop = calculateScrollTopOfPeriodSelector(selectedButtonElement, periodSelectorElement);
    scrollToPositionOfElement(periodSelectorElement, scrollTop);
  };

  const shouldScrollToSelected = () => selectedValue !== undefined && periodSelectorRef.value;

  const getSelectedButtonElement = (): HTMLButtonElement | null => {
    if (selectedValue === undefined) return null;
    const selectedButtonRef = buttonRefs.value.get(selectedValue);
    if (!selectedButtonRef?.$el) return null;
    return selectedButtonRef.$el as HTMLButtonElement;
  };

  const getPeriodSelectorElement = (): HTMLDivElement | null => {
    return periodSelectorRef.value;
  };

  const calculateScrollTopOfPeriodSelector = (
    selectedButtonElement: HTMLButtonElement,
    periodSelectorElement: HTMLDivElement
  ) => {
    const buttonTop = selectedButtonElement.offsetTop;
    const buttonHeight = selectedButtonElement.offsetHeight;
    const periodSelectorHeight = periodSelectorElement.clientHeight;

    return buttonTop - periodSelectorHeight / 2 + buttonHeight / 2;
  };

  const scrollToPositionOfElement = (element: HTMLDivElement, position: number) => {
    element.scrollTo({
      top: Math.max(0, position),
    });
  };

  return {
    setButtonRef,
    scrollToSelected,
  };
};
